import moment from "moment";

/**
 * Audit entries stored on `reservation.history`.
 *
 * The list is bounded by the status machine, so it lives on the reservation
 * document itself and is read with it. Entries are self-contained, which keeps
 * the door open to mirroring them into a global log later.
 */

export const HISTORY_EVENT = {
  CREATED: "created",
  STATUS_CHANGE: "status_change",
};

/** Same session key the rest of the app reads the signed-in user from. */
const getSessionUser = () => {
  try {
    return JSON.parse(sessionStorage.getItem("userDetails") || "{}");
  } catch (error) {
    console.error("Failed to parse userDetails from sessionStorage:", error);
    return {};
  }
};

/**
 * A snapshot of who acted, denormalized on purpose: the entry has to keep
 * reading correctly after the staff record is renamed or removed.
 */
export const getCurrentActor = () => {
  const user = getSessionUser();
  return {
    id: user.id || "",
    name: user.name || user.fullName || user.username || "",
    email: user.email || "",
    role: user.role || user.roles || "",
  };
};

/** Firestore rejects serverTimestamp() inside array items, so time is client-side. */
const createEntry = (type, fields) => ({
  type,
  at: moment().toISOString(),
  by: getCurrentActor(),
  ...fields,
});

export const createdHistoryEntry = ({ status, source }) =>
  createEntry(HISTORY_EVENT.CREATED, {
    to: status || "",
    source: source || "",
  });

export const statusChangeHistoryEntry = ({ from, to }) =>
  createEntry(HISTORY_EVENT.STATUS_CHANGE, {
    from: from || "",
    to: to || "",
  });

/** Falls back through the fields that may be missing on the session user. */
export const describeActor = (by) =>
  by?.name || by?.email || by?.role || by?.id || "Unknown user";
